exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#messages>ul>li{position:relative;background:transparent no-repeat 2px 50%;padding:6px;border-bottom:1px solid hsla(0,0%,100%,.1);transition:height 2s ease}#messages>ul>li:hover{background-color:rgba(0,0,0,.2)}#messages>ul>li .type{position:absolute;top:10px;right:6px;font-size:10px;line-height:10px;background:#eeac32;background:linear-gradient(0deg,rgba(238,172,50,.5),#eeac32);padding:2px 6px 1px;border-radius:6px;text-transform:uppercase}#messages>ul>li .date{font-size:14px;color:#dedede}#messages>ul>li .name{font-size:16px;font-weight:700}#messages>ul>li .archive{position:absolute;top:2px;left:4px;font-size:12px;color:#00b200}#messages>ul>li .body{color:#dedede;font-size:12px;line-height:14px;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-aeea43be!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Message.vue
// module id = 55
// module chunks = 0